import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { WorkShiftService } from '../../services/work-shift.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-update-work-shift',
    templateUrl: './update-work-shift.component.html',
    styleUrls: ['./update-work-shift.component.css', '../../app.component.css']
})

export class UpdateWorkShiftComponent implements OnInit {

    workShiftForm: FormGroup;
    workShift: any = [];

    pickatimeParams = Utils.pickatimeParams();

    id: string;

    gwsSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private workShiftService: WorkShiftService) {
        this.activatedRoute.params.subscribe(parameters => {
            
            this.id = parameters['id'];

            this.gwsSubs = this.workShiftService.getWorkShift(this.id).subscribe(workShiftObj => {
                this.gwsSubs.unsubscribe();

                this.workShift = workShiftObj;
            });
        });
    }

    ngOnInit() {
        this.workShiftForm = this.formBuilder.group({
            name: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', [Validators.required]]
        });
    }

    onSubmitWorkShift() {
        this.workShift = this.saveWorkShift();

        this.workShiftService.putWorkShift(this.workShift, this.id).then(res => {
            this.router.navigate(['/work_shifts']);
        });
    }

    saveWorkShift() {
        const workShitJson = {
            endTime: this.workShiftForm.get('endTime').value,
            name: this.workShiftForm.get('name').value,
            startTime: this.workShiftForm.get('startTime').value,
            updatedAt: new Date()
        };

        return workShitJson;
    }

}
